import React from 'react';
import styles from './index.module.less';
import { Modal, Button } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';
import Link from '@base/lib/ThemeLink';
import site from 'pro/config/site';
import { useTrans, Trans } from 'base/utils/i18n';

type SubscribeModalProps = {
    visible: boolean;
    onCancel: () => void;
    className?: string;
};

const SubscribeModal: React.FC<SubscribeModalProps> = props => {
    const { visible, onCancel, className } = props;
    const { t } = useTrans();

    return (
        <Modal
            width={500}
            open={visible}
            onCancel={onCancel}
            footer={false}
        >
            <div className={className || styles.modal}>
                <p className="line1"><CheckCircleOutlined className="result-icon"/></p>
                <p className="line2">{t('web_subscribe_result_text_1')}</p>
                <p className="line3">{t('web_subscribe_result_text_2')}</p>
                <p className="line3">
                    <Trans
                        i18nKey="web_subscribe_result_text_3"
                        values={{ discount: site.registerActivity.discount }}
                        components={{ CouponCode: <strong className="code">{site.registerActivity.couponCode}</strong> }}
                    />
                </p>
                <p>
                    <Button
                        href={'/weekly-deal'}
                        type="primary"
                        size="large"
                        className="btn-ok"
                        onClick={onCancel}
                    >
                        {t('web_subscribe_result_btn_text')}
                    </Button>
                </p>
                <p>
                    <Link href="https://www.facebook.com/groups/477264677334391">
                        <a className={'join'} target="_blank" rel="nofollow noopener noreferrer">
                            {t('web_subscribe_result_join_community')}
                        </a>
                    </Link>
                </p>
            </div>
        </Modal>
    )
};

export default SubscribeModal;